module.exports = __webpack_public_path__ + "thyroid-factors.d2c0a32a376925db204222a0d60ab232.png";